/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import { Text, TextInputProps, TextStyle, View, TouchableOpacity } from 'react-native';
import styles from '../styles';
import { formsStyles } from '../formStyles';
import { FilePickerWeb } from '../FilePicker/FilePickerWeb';

interface Props extends TextInputProps {
    name: string;
    label?: string;
    labelStyle?: TextStyle;
    type?: string;
    callback?:any;
}

export default React.forwardRef<any, Props>(
    (props, ref): React.ReactElement => {
        const {
            label,
            callback
        } = props;

        const [image, setImage] = useState<string>();

        const handleFile = (acceptedFiles: any) => {
          callback(acceptedFiles)
            setImage(acceptedFiles.map((file: any) => file.name));
        };

        return (
            <View style={styles.container}>
                {label && (
                    <Text style={[formsStyles.labelStyle]}>
                        {label}
                    </Text>
                )}
                 <TouchableOpacity>
                    <FilePickerWeb callback={handleFile} type='fileNoLabel' />
                </TouchableOpacity>

            </View>
        );
    },
);
